import {cardTitle, primaryColor, secondaryColor, title} from "../../../nextjs-material-kit.js";
import imagesStyle from "../../../nextjs-material-kit/imagesStyles.js";
import { container, containerFluid } from "../../../nextjs-material-kit.js";
import {insetLogoSize} from "../../const";

const logoPadding = '10px';

const detailsStyle = (theme) => ({
  bg_colored: {
    backgroundColor: "#eaf6fe",
  },
  employerLogoInnerContainer: {
    padding: logoPadding,
    border: "1px solid #27B0AE",
    backgroundColor: "white",
    width: insetLogoSize,
    height: insetLogoSize,
  },
  employerLogoOuterContainer: {
    position: "absolute",
    zIndex: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bottom: "-35px",
    left: "20px",
    width: `calc(${insetLogoSize} + ${logoPadding})`,
    height: `calc(${insetLogoSize} + ${logoPadding})`,
  },
  employerLogo: {
    // `backgroundImage` to be set dynamically inline.
    height: `calc(${insetLogoSize} - ${logoPadding} - ${logoPadding})`,
    width: `calc(${insetLogoSize} - ${logoPadding} - ${logoPadding})`,
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  },
  homeSearchButton: {
    fontSize: "16px",
    marginTop: "0",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 700,
    textTransform: "none",
    backgroundColor: "#095a70",
    marginBottom: "0px",
    lineHeight: "16px",
    display: "inline-flex",
    boxShadow: "none",
    padding: "8px 30px",
    "&:hover": {
      backgroundColor: "#00acc1",
    },
    "@media (max-width: 768px)": {
      width: "100% !important",
    },
  },
  // Mostly as per job overview, except the different header layout means we don't
  // want a min height even at mobile size.
  itemGrid: {
    height: "0",
    minHeight: "0",
    marginLeft: "auto",
    marginRight: "auto",
    borderRadius: "0",
    padding: "0px",
    border: "0",
    borderBottom: "none",
  },
  // Designed to override auto grids' -ve margin and +ve padding.
  marginAuto: {
    marginLeft: "0",
    marginRight: "0",
    paddingLeft: "0",
    paddingRight: "0",
  },
  marginBelow: {
    marginBottom: "20px",
  },
  paddingZero: {
    "@media (max-width: 768px)": {
      padding: "0 !important",
    },
  },
  cardArea: {
    margin: "0 0 15px 0",
    padding: '20px 0',
    backgroundColor: "#eaf6fe",
  },
  section: {
    padding: "70px 0",
    textAlign: "center",
  },
  container: {
    ...container(theme),
  },
  relativeContainer: {
    position: "relative",
    ...container(theme),
  },
  primaryColor: {
    backgroundColor: "#095a70",
    marginLeft: "-15px",
    marginTop: "15px",
  },
  title: {
    ...title,
    marginBottom: "1rem",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
  },
  ...imagesStyle,
  cardFooter: {
    padding: "0.9375rem 15px !important",
    alignItems: "flex-start",

    "@media (max-width:  768px)": {
      padding: "0.9375rem 0 !important",
    },

    ".MuiGrid-styledGridItem": {
      padding: "0 !important",
    },
  },
  floatRight: {
    float: "right",
  },
  jobIcons: {
    cursor: "pointer",
  },
  cardTitle: {
    ...cardTitle,
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    textAlign: "left",
    color: primaryColor,
    fontSize: "60px",
    margin: "0 !important",
  },
  cardTitleSmaller: {
    ...cardTitle,
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    textAlign: "left",
    color: primaryColor,
    fontSize: "40px",
    margin: "0 !important",
  },
  noMargin: {
    padding: "0px !important",
  },
  smallTitle: {
    color: "#6c757d",
  },
  justifyCenter: {
    justifyContent: "center !important",
  },
  socials: {
    marginTop: "0",
    width: "100%",
    transform: "none",
    left: "0",
    top: "0",
    height: "100%",
    lineHeight: "41px",
    fontSize: "20px",
    color: "#999",
  },
  margin5: {
    margin: "5px",
  },
  floatLeft: {
    float: "left",
    "@media (max-width: 768px)": {
      padding: 0,
    },
  },
  titles: {
    paddingLeft: "15px",
    paddingRight: "15px",
    "@media (max-width: 768px)": {
      paddingLeft: 0,
      paddingRight: 0,
    },
  },
  mainContent: {
    paddingBottom: "2rem",
  },
  detailsBtn: {
    marginTop: "22px",
    width: "33% !important",
  },
  moreBtn: {
    marginTop: "22px",
    width: "20% !important",
  },
  communityBtn: {
    "@media (max-width: 768px)": {
      marginTop: "10px",
      marginLeft: "0",
    },
    "@media (min-width: 768px)": {
      marginLeft: "15px",
      marginTop: "0",
    },
  },
});

export default detailsStyle;
